import React from "react";
import AnswerCard from "./AnswerCard";
import ClarifyCard from "./ClarifyCard";
import NavigationResult from "./NavigationResult";

// AssistantAnswer dispatches an assistant response to the SP1 card matching
// its `intent` — the single shared renderer for both the slide-over
// AnalysisPanel thread and the full-page AnalysisWorkspacePage thread, so the
// two hosts render identically.
export default function AssistantAnswer({ response, onNavigate, onChip, onFollowup }) {
  if (!response) return null;
  // "lookup" (governed-lookup answers: unallocated / top owners / pending
  // budgets) shares the exact same answer/metrics/navigation_actions shape as
  // "analyze", so it renders via the same AnswerCard.
  if (response.intent === "analyze" || response.intent === "lookup")
    return <AnswerCard response={response} onNavigate={onNavigate} onFollowup={onFollowup} />;
  if (response.intent === "clarify") return <ClarifyCard clarify={response.clarify} onChip={onChip} />;
  if (response.intent === "navigate") return <NavigationResult navigation={response.navigation} onGo={onNavigate} />;
  // Defensive fallback: an unrecognized intent that still carries a rendered
  // answer payload should not silently render blank — render it via
  // AnswerCard rather than dropping it.
  if (response.answer) return <AnswerCard response={response} onNavigate={onNavigate} onFollowup={onFollowup} />;
  return null;
}
